import {Injectable} from "@angular/core";
import {WebSocketLink} from "apollo-link-ws";
import {HttpLink, HttpLinkHandler} from "apollo-angular-link-http";
import {SubscriptionClient} from "subscriptions-transport-ws";
import {ApolloLink, split} from "apollo-link";
import {getMainDefinition} from "apollo-utilities";

@Injectable()
export class GraphqlManagerService {
  private readonly subscriptionClient: SubscriptionClient;
  private readonly webSocketLinkHandler: WebSocketLink;
  private readonly httpLinkHandler: HttpLinkHandler;

  apolloLink: ApolloLink;

  constructor(private httpLink: HttpLink) {
    const secure = /https/i.test(window.location.protocol);
    const base = secure ? "wss" : "ws";
    this.subscriptionClient = new SubscriptionClient(`${base}://${window.location.host}/graphql`, {reconnect: true});
    this.webSocketLinkHandler = new WebSocketLink(this.subscriptionClient);
    this.httpLinkHandler = httpLink.create({uri: "/graphql", withCredentials: true});

    this.apolloLink = split(
      ({query}) => {
        const {kind, operation} = getMainDefinition(query);
        return (kind === "OperationDefinition" && operation === "subscription");
      },
      this.webSocketLinkHandler,
      this.httpLinkHandler,
    );
  }

  restartWebsockets() {
    this.subscriptionClient.close(false, false);
  }
}
